import React, { Fragment, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import '../styles/_header.scss';

const Header = ({ user, onLogout }) => {
  const [burgerOpen, setBurgerOpen] = useState(false);
  const path = useLocation().pathname;

  return (
    <div className="dashboard-header">
      {user.isAdmin &&
        <div className="header-left">
          <img src="/logo_admin.png" alt="quick quality car wash logo" />
          <Link to="/admin/members">
            <div className={`btn primary ${path.includes('members') && !path.includes('tier') ? 'active' : ''}`}>
              Club Members
            </div>
          </Link>
          <Link to="/admin/activity">
            <div className={`btn primary ${path.includes('activity') ? 'active' : ''}`}>
              Activity
            </div>
          </Link>
        </div>
      }
      {!user.isAdmin &&
        <div className="header-left">
          <img src="/logo.png" alt="quick quality car wash logo" />
        </div>
      }
      <div className="header-right">
        <div className="welcome">
          <p className="smaller">Welcome Back</p>
          <p>{user.prefix} {user.lastName}</p>
        </div>
        <div className={`burger-button ${burgerOpen ? 'open' : ''}`} onClick={() => setBurgerOpen(!burgerOpen)}>
          <div className={`${burgerOpen ? 'open' : ''}`}></div>
          <div className={`${burgerOpen ? 'open' : ''}`}></div>
          <div className={`${burgerOpen ? 'open' : ''}`}></div>
        </div>
      </div>
      <div className={`header-dropdown ${burgerOpen ? 'active' : ''}`}>
        {user.isAdmin &&
          <Fragment>
            <Link to="/admin/membership-tiers">Membership Tiers</Link>
            <Link to="/admin/members">Club Members</Link>
            <Link to="/admin/activity">Wash Activity</Link>
            <Link to="/dashboard">My Profile</Link>
          </Fragment>
        }
        <a href="https://members.quikqualitycarwash.com/QuikQualityPrivacyPolicy.pdf" target="_blank" rel="noreferrer">Privacy Policy</a>
        <Link to="/">
          <div onClick={() => onLogout()}>Logout</div>
        </Link>
      </div>
    </div>
  )
}

export default Header